import { render, staticRenderFns } from "./CPrgTree.vue?vue&type=template&id=07f059a5&scoped=true&"
import script from "./CPrgTree.vue?vue&type=script&lang=ts&"
export * from "./CPrgTree.vue?vue&type=script&lang=ts&"
import style0 from "./CPrgTree.vue?vue&type=style&index=0&id=07f059a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f059a5",
  null
  
)

export default component.exports